import React, { FC, useContext, useEffect, useState } from 'react'

import { AdyenContext2 } from '@Domains/Checkout/Providers/AdyenContextProvider'
import { buildAdyenComponent } from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutPaymentStep/Components/ProviderComponents/Adyen/Hooks/useAdyen'
import {
  useAdyenCheckoutResponse,
} from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutPaymentStep/Components/ProviderComponents/Adyen/Hooks/useAdyenCheckoutResponse'
import { CheckoutPaymentComponentProps } from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutPaymentStep/Hooks/usePaymentComponentFactory'

import styles from './AdyenPaypal.module.scss'

export const AdyenPaypalButton: FC<CheckoutPaymentComponentProps> = ({
  option,
  submitPayment,
}) => {
  const {
    adyenConfig,
    adyenInstance,
  } = useContext(AdyenContext2)
  const { handleAdyenResponse } = useAdyenCheckoutResponse()
  const [adyenComponent, setAdyenComponent] = useState(null)

  useEffect(() => {
    if (adyenComponent) {
      return
    }
    const component = buildAdyenComponent(adyenInstance, 'paypal', `#paypal_${option.id}`, adyenConfig, {
      intent: 'authorize',
      onInit: (data, actions) => {
        actions.disable()
      },
      onClick: () => {
        submitPayment({
          clientStateDataIndicator: true,
          paymentMethod: {
            type: 'paypal',
          },
        }, response => handleAdyenResponse(adyenInstance, response))
      },
      onsubmit: undefined,
    })
    setAdyenComponent(component)
  }, [adyenComponent, adyenConfig, adyenInstance, handleAdyenResponse, option.id, submitPayment])

  return (
    <div key={option.id} className={styles.paypalButtonWrapper}>
      <div className={styles.paypalButton} id={`paypal_${option.id}`} />
    </div>
  )
}
